<template>
  <div>
    <h3 class="align_left">
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Contenu mis en avant
    </h3>
    <b-row>
      <b-col sm="9">
        <b-row v-if="featured_content.length > 0">
          <b-col
            style="margin-bottom: 20px"
            cols="12"
            v-for="(block, index) in featured_content"
            :key="index"
          >
            <TextBlockContainer
              v-if="block.type === 'text'"
              :content="block.content"
              :index="index"
              :key="index"
              @updateContent="updateTextContent"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></TextBlockContainer>
            <ImageBlockContainer
              v-if="block.type === 'image'"
              :index="index"
              :image_property="block"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></ImageBlockContainer>
            <ButtonBlockContainer
              v-if="block.type === 'button'"
              :index="index"
              :button_property="block"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></ButtonBlockContainer>
            <IframeBlockContainer
              v-if="block.type === 'iframe'"
              :index="index"
              :iframe_property="block"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></IframeBlockContainer>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <b-alert show variant="warning"
              >Aucun contenu mis en avant pour cet évènement, ajouter des élements via la
              sidebar</b-alert
            >
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="3">
        <div id="sidebar_parcours_builder">
          <h3>Elements</h3>
          <b-button @click="addBlockText()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Bloc de
            texte</b-button
          >
          <b-button @click="addBlockImage()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Image</b-button
          >
          <b-button @click="addBlockButton()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Bouton</b-button
          >
          <b-button @click="addBlockIframe()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Iframe</b-button
          >
          <hr />
          <h3>Couleurs</h3>
          <color-panel
            v-model="picked_color"
            style="max-width: 100%; margin-top: 10px"
          ></color-panel>
        </div>
      </b-col>
    </b-row>
    <hr />
    <div id="galery_container">
      <div class="title_step">
        <h2>
          <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
          Galerie photo
        </h2>
      </div>
      <p>
        La galerie photo vous permet d'importer des images sur le serveur afin
        de les placer sur une page parcours. <br />
        Pour cela cliquer sur le bouton "add image" afin de l'importer. Elle
        apparaitra ainsi dans la galerie.<br />
        Cliquer sur l'image désirée, puis le bouton "copy link", et coller le
        lien dans le champs url du bloc image.
      </p>
      <ImageGalery></ImageGalery>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TextBlockContainer from "@/components/Admin_tab/Blocks/TextBlockContainer.vue";
import ImageBlockContainer from "@/components/Admin_tab/Blocks/ImageBlockContainer.vue";
import ButtonBlockContainer from "@/components/Admin_tab/Blocks/ButtonBlockContainer.vue";
import IframeBlockContainer from "@/components/Admin_tab/Blocks/IframeBlockContainer.vue";
import ImageGalery from "@/components/Admin_tab/ImageGalery.vue";
import { TextBlock } from "@/classes/Blocks/TextBlock.js";
import { ImageBlock } from "@/classes/Blocks/ImageBlock.js";
import { ButtonBlock } from "@/classes/Blocks/ButtonBlock.js";
import { IframeBlock } from "@/classes/Blocks/IframeBlock.js";
export default {
  components: {
    TextBlockContainer,
    TextBlock,
    ImageBlockContainer,
    ImageBlock,
    ButtonBlockContainer,
    ButtonBlock,
    IframeBlockContainer,
    IframeBlock,
    ImageGalery,
  },
  props: ["featured_content"],
  data() {
    return {
      picked_color: "#000",
    };
  },
  methods: {

    addBlockText() {
      let block = new TextBlock("text");
      this.featured_content.push(block);
    },
    addBlockImage() {
      let block = new ImageBlock("image");
      this.featured_content.push(block);
    },
    addBlockButton() {
      let block = new ButtonBlock("button");
      this.featured_content.push(block);
    },
    addBlockIframe() {
      let block = new IframeBlock("iframe");
      this.featured_content.push(block);
    },
    shiftUpBlock(index) {
      var block = this.featured_content[index];
      this.featured_content.splice(index, 1);
      this.featured_content.splice(index - 1, 0, block);
      this.$forceUpdate();
    },
    shiftDownBlock(index) {
      var block = this.featured_content[index];
      this.featured_content.splice(index, 1);
      this.featured_content.splice(index + 1, 0, block);
      this.$forceUpdate();
    },
    deleteBlock(index) {
      this.featured_content.splice(index, 1);
      this.$forceUpdate();
    },
    updateTextContent(args) {
      this.featured_content[args.index].content = args.content;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>